import AktenDetailSidebar from './container'
export { AktenDetailSidebar }
export default AktenDetailSidebar